// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__2SnXi","row":"styles_row__2q-OH"};